(function () {
  "use strict";

  angular
    .module("alk.forms")
    .directive("alkForgotPassword", alkForgotPassword);

  alkForgotPassword.$inject = [];

  function alkForgotPassword() {

    var directive = {
      template: require("./forgotPassword.html"),
      restrict: "E",
      scope: {
        controllerName: "@",
      },
      //Use the passed-in controller-name attribute to create its controller
      controller: ["$controller", "$scope", function($controller, $scope) {
        var c = $controller($scope.controllerName, {$scope: $scope});
        return c;
      }],
    };

    return directive;
  }

})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-forms/forgot/forgotPassword.directive.js